import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const superAdmin = createAsyncThunk(
  "superAdmin/fetch",
  async (_, { rejectWithValue, serializeError }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/GetAllUsers`);
      return response.data;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const superAdminSlice = createSlice({
  name: "superAdmin",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(superAdmin.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(superAdmin.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(superAdmin.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export default superAdminSlice.reducer;
